<template lang="pug">
    .start-page
        router-link(to="/").start-page-logo
            img(src="@/assets/img/logo-white.png" alt="logo")
        transition(name="slide-fade" mode="out-in")
          router-view
</template>

<script>
export default {
}
</script>

<style lang="scss">
.start-page{
    padding: 50px;
    height: 100vh;
    background-color: #008cff;
    background-image: linear-gradient(to right, #008cff 0%, #b533eb 100%);
    box-sizing: border-box;
    overflow-x: hidden;
    &-logo{
        width: 82px;
        height: 82px;
        display: block;
        margin: 0 auto 40px;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>